var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo2625(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2625",
    "data-name": "Grupo 2625",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.253,
    height: 38.252,
    viewBox: "0 0 38.253 38.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1706",
    "data-name": "Trazado 1706",
    d: "M19.127,39.159A19.126,19.126,0,1,1,38.253,20.034,19.147,19.147,0,0,1,19.127,39.159m0-37.19A18.064,18.064,0,1,0,37.19,20.034,18.084,18.084,0,0,0,19.127,1.97",
    transform: "translate(0 -0.907)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1707",
    "data-name": "Trazado 1707",
    d: "M10.072,26.328H7.288V23.559h2.785V20.725H12.94v2.835h2.785v2.768H12.94v2.834H10.072Z",
    transform: "translate(-1.818 -5.85)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1708",
    "data-name": "Trazado 1708",
    d: "M22.663,21.578l-1.945.445-.609-2.472,3.378-.956H25.81V30.213H22.663Z",
    transform: "translate(-5.015 -5.319)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1709",
    "data-name": "Trazado 1709",
    d: "M34.537,30.372a6.991,6.991,0,0,1-1.912-.247,4.834,4.834,0,0,1-1.5-.692,3.336,3.336,0,0,1-.98-1.063,2.715,2.715,0,0,1-.354-1.376v-.033a2.689,2.689,0,0,1,.519-1.714,3.561,3.561,0,0,1,1.458-1.055,3.64,3.64,0,0,1-1.129-.973,2.451,2.451,0,0,1-.453-1.532v-.033a2.666,2.666,0,0,1,.313-1.278,3.133,3.133,0,0,1,.89-1.022,4.283,4.283,0,0,1,1.376-.676,6.692,6.692,0,0,1,3.543,0,4.283,4.283,0,0,1,1.376.676,3.133,3.133,0,0,1,.89,1.022,2.666,2.666,0,0,1,.313,1.278v.033a2.451,2.451,0,0,1-.453,1.532,3.657,3.657,0,0,1-1.129.973,4.728,4.728,0,0,1,.808.453,2.856,2.856,0,0,1,.618.585,2.637,2.637,0,0,1,.4.75,2.882,2.882,0,0,1,.149.964v.033a2.8,2.8,0,0,1-.354,1.4,3.307,3.307,0,0,1-.98,1.071,4.723,4.723,0,0,1-1.5.684,7.239,7.239,0,0,1-1.912.239m0-2.389a1.784,1.784,0,0,0,1.236-.387,1.2,1.2,0,0,0,.428-.914v-.033a1.083,1.083,0,0,0-.461-.907,2.265,2.265,0,0,0-2.406,0,1.081,1.081,0,0,0-.461.907v.033a1.2,1.2,0,0,0,.428.914,1.784,1.784,0,0,0,1.236.387m0-4.663a1.465,1.465,0,0,0,1.03-.354,1.165,1.165,0,0,0,.387-.9v-.032a1.155,1.155,0,0,0-.379-.849,1.423,1.423,0,0,0-1.038-.371,1.438,1.438,0,0,0-1.038.363,1.129,1.129,0,0,0-.379.841v.033a1.19,1.19,0,0,0,.387.906,1.446,1.446,0,0,0,1.03.363",
    transform: "translate(-7.43 -5.28)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo2625);
export default __webpack_public_path__ + "static/media/Grupo 2625.5368aca6b5bd36f41f169acba2184ac6.svg";
export { ForwardRef as ReactComponent };